import { CriteriaBase } from '@/shared/models/CriteriaBase.model';
import { CommandeStatut } from '@/shared/enums/CommandeStatut.enum';

/**
 * Modèle pour les filtres de recherche de commande.
 * */
export class CommandeCriteria extends CriteriaBase {
    /**
     * Recherche d'une commande.
     */
    public recherche: string = '';

    /**
     * Recherche sur une date de début minimale.
     */
    public dateDebut: string = '';

    /**
     * Recherche sur une date de fin maximale.
     */
    public dateFin: string = '';

    /**
     * Recherche sur l'identifiant Pce.
     */
    public identifiantPce: string = '';

    /**
     * Filtre sur le type de commande.
     */
    public typeCommandeCode: string = '';

    /**
     * Filtre sur le contrat d'achat lié à la commande.
     */
    public contratAchatGroupeIds: number[] = [];

    /**
     * Filtre sur le statut de la commande.
     */
    public statutCommande: CommandeStatut | null = null;
}
